import { all, fork } from 'redux-saga/effects'
import userDataSaga from './userDataSaga';

export default function* rootSaga() {
  yield all([fork(userDataSaga)])
}
